import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D282 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D282 - Cloud Foundations</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 17.12 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            I did the whole Udemy course from Stephen Marek for this one: AWS
            Certified Cloud Practitioner. Make sure you follow along and get
            hands-on as the videos progress—it's a super fun course. I took my
            time for this one since the Udemy course is quite long, but
            definitely worth it. It will also help you later in the capstone
            project if you decide to deploy on AWS.
          </p>
          <p>
            I did the practice tests the instructor sent and scored around
            60-75% on them. The Amazon test itself was soooo easy—the questions
            were very basic, and I passed with 100%.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D282;
